import { Station } from 'entities/stations';
import { checkIsSelectedStation } from './checkIconTypes';
import { ROADSIDE_SERVICES_CODES } from 'entities/roadsideServices';

import { MARKER_TYPES } from 'entities/map';

const getActionStatus = (actions: any[]) => (
  actions && actions.length ? 'Action' : ''
);

const getActiveStatus = (
    stationCode: Station['code'],
    selectedStationCode: Station['code']
) => (
  checkIsSelectedStation(stationCode, selectedStationCode) 
  ? 'Active' : ''
);

const getFavouriteStatus = (favourite: boolean) => (
  favourite ? 'Favourite' : ''
);

const getStationType = (categoryCode: number) => ({
  2: MARKER_TYPES.discountPlusPetrolStation,
  4: MARKER_TYPES.powerMaxPetrolStation,
  5: MARKER_TYPES.economyPetrolStation
}[categoryCode]);

export const getMapStationIconName = ({
  data,
  clusterWeight = 0,
  selectedStation
}: any) => {
  if (clusterWeight > 1) {
    return clusterWeight < 1000 ? 'cluster' : 'largeCluster'
  }

  if (!data.code) {
    return 'place';
  }

  const isGasStation = data.roadsideServiceCodes[0] === ROADSIDE_SERVICES_CODES.gasStation;

  if(!data.roadsideServiceCodes.length || (isGasStation && !getStationType(data.categoryCode))) {
    return 'station'
      + getActiveStatus(data.code, selectedStation)
      + getFavouriteStatus(data.favourite)
      + '1';
  }

  if (isGasStation) {
    return 'station'
      + getActiveStatus(data.code, selectedStation)
      + getActionStatus(data.actions)
      + getFavouriteStatus(data.favourite)
      + data.categoryCode
  }

  return 'roadsideService'
    + getActiveStatus(data.code, selectedStation)
    + getActionStatus(data.actions)
    + getFavouriteStatus(data.favourite)
    + data.roadsideServiceCodes[0];
};
